import { useMemo } from 'react';

import { getColumnDefs } from './NetSuiteVendorSubsidiaryList.config';

export const useTableDefinitions = () => {
    const subsidiaryListTableDefinition = useMemo(() => getColumnDefs(), []);

    return subsidiaryListTableDefinition;
};
